module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "groupPageAndEditor",
    class: {
      openEditor: _vm.openEditor
    },
    on: {
      "dragover": function($event) {
        return _vm.onDragOver($event)
      }
    }
  }, [_c('div', {
    staticClass: "groupPage-container"
  }, [(_vm.hasError) ? [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center tpadding bigPadding"
  }, [_vm._m(0), _c('h4', [_vm._v(_vm._s(_vm.$t('groupPages.noExistingGroup.title')))]), _c('br'), _c('br'), _c('p', [_vm._v(_vm._s(_vm.$t('groupPages.noExistingGroup.description1')))]), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: "GroupPage"
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('groupPages.noExistingGroup.description2')))])], 1)])])] : [(!_vm.group && _vm.user) ? [_c('div', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('groupPages.title'))), (_vm.groops.length > 0) ? _c('small', [_vm._v(_vm._s(_vm.$t('groupPages.subtitle')))]) : _vm._e()]), _c('small', [_vm._v(" ")]), _c('div', {
    staticClass: "alert alert-info text-muted"
  }, [_vm._v(_vm._s(_vm.$t('groupPages.description')))])]), (_vm.groops.length > 0) ? _c('select-a-group', {
    on: {
      "select-group": _vm.selectOtherGroup
    }
  }) : _c('div', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "alert alert-warning text-muted"
  }, [_vm._v(_vm._s(_vm.$t('groupPages.noGroup.intro')))])])] : _vm._e(), (!_vm.group && !_vm.shownGroup) ? [_c('div', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('groupPages.publicPages.title'))), (_vm.cacheGroupsToExplore.status == _vm.STATUS.LOADING) ? _c('small', [_c('i', {
    staticClass: "fa fa-spin fa-refresh"
  }), _vm._v("  " + _vm._s(_vm.$t('globals.loading')))]) : _vm._e(), (_vm.cacheGroupsToExplore.status == _vm.STATUS.LOADED) ? _c('small', [_vm._v(_vm._s(Object.keys(_vm.groupsToExplore).length) + " " + _vm._s(_vm.$t('groupPages.publicPages.groups')))]) : _vm._e()]), _c('small', [_vm._v(" ")]), _c('div', {
    staticClass: "alert alert-info text-muted"
  }, [_vm._v(_vm._s(_vm.$t('groupPages.publicPages.description')))]), _c('div', {
    staticClass: "text-center"
  }, _vm._l((_vm.groupsToExplore), function(group) {
    return _c('div', {
      key: group.id,
      staticClass: "card",
      on: {
        "click": function($event) {
          return _vm.selectOtherGroup(group)
        }
      }
    }, [_c('vue-object-img', {
      attrs: {
        "object": group
      }
    }), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(group.id) + " - " + _vm._s(group.name))])], 1)
  }), 0)])] : _vm._e(), (_vm.group && !_vm.hasError) ? _c('div', {
    staticClass: "groupPage"
  }, [(_vm.openEditor) ? _c('div', {
    ref: "changePictureModal",
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('groupPages.page.changeGroupPicture')))])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('change-avatar', {
    ref: "changeAvatar",
    attrs: {
      "object": _vm.group
    }
  })], 1)])])])]) : _vm._e(), _c('div', {
    staticClass: "fixedHeader"
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.group
    }
  }), _c('h1', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.group.name))])], 1), _c('div', {
    staticClass: "introduction"
  }, [_c('div', {
    staticClass: "backgroundImage",
    style: (_vm.background),
    on: {
      "mouseup": _vm.onChangeBackgroundImageClick
    }
  }, [(_vm.openEditor) ? _c('i', {
    staticClass: "editBtn fa fa-picture-o"
  }) : _vm._e(), (_vm.openEditor) ? _c('i', {
    staticClass: "editBtn fa fa-arrows-v",
    class: {
      active: _vm.movingBackground
    },
    on: {
      "mousedown": _vm.startMoveBackgroundPicture
    }
  }) : _vm._e()]), (_vm.group.hasPicture || _vm.openEditor) ? _c('vue-object-img', {
    attrs: {
      "object": _vm.group
    },
    on: {
      "click": _vm.onProfileImageClick
    }
  }) : _vm._e(), (_vm.openEditor) ? _c('i', {
    staticClass: "editBtn forProfileImg fa fa-picture-o"
  }) : _vm._e(), _c('h1', {
    staticClass: "name",
    on: {
      "click": _vm.onNameClick
    }
  }, [_vm._v(_vm._s(_vm.group.name))]), _c('h2', {
    staticClass: "punchLine",
    on: {
      "click": _vm.onPunchLineClick
    }
  }, [_vm._v(_vm._s(_vm.group.pageSentence || (_vm.openEditor ? _vm.$t('groupPages.page.punchLineDefault') : "")))]), _c('h3', {
    staticClass: "privacity"
  }, [(_vm.group.isPublic) ? [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('groupPages.page.publicGroup')))] : [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" " + _vm._s(_vm.$t('groupPages.page.privateGroup')))]], 2), (_vm.group.page) ? _c('div', {
    ref: "heartContainer",
    staticClass: "like",
    class: {
      followed: _vm.group.followed
    },
    attrs: {
      "title": _vm.group.followed ? _vm.$t("groupPages.followed.yes") : _vm.$t("groupPages.followed.no")
    },
    on: {
      "click": _vm.toggleFollow
    }
  }, [_c('i', {
    ref: "heart",
    staticClass: "fa fa-heart"
  }), _c('div', {
    ref: "heartText",
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.group.page.nbFollowers) + " " + _vm._s(_vm.$tc("groupPages.followed.fans", _vm.group.page.nbFollowers)) + " ")]), (_vm.group.followed) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("groupPages.followed.withYou")) + " ")]) : _vm._e()]) : _vm._e()], 1), (_vm.modules.length > 0) ? _c('div', {
    staticClass: "menu"
  }, [_c('ul', _vm._l((_vm.modules), function(module) {
    return _c('li', [_c('a', {
      attrs: {
        "data-goto": '#' + module.code
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("groupPages.modules." + module.code + ".title"))), (_vm.hasBadge(module)) ? _c('div', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(_vm._f("nb")(module)))]) : _vm._e()])])
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "blocks"
  }, [_vm._l((_vm.modules), function(module) {
    return _c('div', {
      staticClass: "block"
    }, [_c('a', {
      attrs: {
        "id": module.code
      }
    }), (module.type == "newMember") ? _c('group-page-new-member', {
      attrs: {
        "vue-data": _vm.vueData,
        "module": module,
        "open-editor": _vm.openEditor,
        "can-edit": _vm.canEdit
      }
    }) : _vm._e(), (module.type == "description") ? _c('group-page-description', {
      attrs: {
        "vue-data": _vm.vueData,
        "module": module,
        "open-editor": _vm.openEditor
      }
    }) : _vm._e(), (module.type == "pictures") ? _c('group-page-pictures', {
      attrs: {
        "vue-data": _vm.vueData,
        "module": module,
        "open-editor": _vm.openEditor
      },
      on: {
        "askUpload": function($event) {
          return _vm.$refs.uploader.askFiles()
        }
      }
    }) : _vm._e(), (module.type == "events") ? _c('group-page-events', {
      attrs: {
        "vue-data": _vm.vueData,
        "module": module,
        "open-editor": _vm.openEditor
      },
      on: {
        "update": function($event) {
          return _vm.askGroupPageInfo(true)
        }
      }
    }) : _vm._e(), (module.type == "audios") ? _c('group-page-audios', {
      attrs: {
        "vue-data": _vm.vueData,
        "module": module,
        "open-editor": _vm.openEditor
      },
      on: {
        "askUpload": function($event) {
          return _vm.$refs.uploader.askFiles()
        }
      }
    }) : _vm._e(), (module.type == "videos") ? _c('group-page-videos', {
      attrs: {
        "vue-data": _vm.vueData,
        "module": module,
        "open-editor": _vm.openEditor
      }
    }) : _vm._e(), (module.type == "links") ? _c('group-page-links', {
      attrs: {
        "vue-data": _vm.vueData,
        "module": module,
        "open-editor": _vm.openEditor
      }
    }) : _vm._e(), (module.type == "nodes") ? _c('group-page-nodes', {
      attrs: {
        "vue-data": _vm.vueData,
        "module": module,
        "open-editor": _vm.openEditor
      },
      on: {
        "askUpload": function($event) {
          return _vm.$refs.uploader.askFiles()
        },
        "update": function($event) {
          return _vm.askGroupPageInfo(true)
        }
      }
    }) : _vm._e(), (module.type == "contact") ? _c('group-page-contact', {
      attrs: {
        "vue-data": _vm.vueData,
        "module": module,
        "open-editor": _vm.openEditor
      }
    }) : _vm._e()], 1)
  }), (_vm.modules.length == 0) ? _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "pcenter"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin bigIcon"
  }), _c('br'), _vm._v(_vm._s(_vm.$t("globals.loading")))])]) : _vm._e()], 2), _vm._m(1)]) : _vm._e()]], 2), (_vm.canEdit) ? _c('div', {
    staticClass: "groupPage-editor",
    class: {
      open: _vm.openEditor
    }
  }, [_c('div', {
    staticClass: "toggleEditorBtn",
    attrs: {
      "title": "Vous avez les droits d'édition de cette page"
    },
    on: {
      "click": _vm.toggleEditor
    }
  }, [(_vm.openEditor) ? [_vm._v(_vm._s(_vm.$t('groupPages.page.closeEditor')))] : _vm._e(), _c('i', {
    staticClass: "fa",
    class: {
      "fa-pencil": !_vm.openEditor, "fa-times": _vm.openEditor
    }
  })], 2)]) : _vm._e(), _c('uploader', {
    ref: "uploader",
    attrs: {
      "options": _vm.uploaderOptions
    },
    on: {
      "fileUploaded": _vm.fileUploaded
    },
    scopedSlots: _vm._u([{
      key: "file",
      fn: function(props) {
        return [_c('div', {
          staticClass: "fileUploader"
        }, [_c('div', [_c('div', {
          staticClass: "pull-right"
        }, [_c('span', {
          on: {
            "click": function($event) {
              return _vm.stopFile(props.fileInfo)
            }
          }
        }, [(props.fileInfo.status == _vm.uploaderConsts.UPLOADING) ? [_c('i', {
          staticClass: "fa fa-stop-circle"
        })] : [_c('i', {
          staticClass: "fa fa-times-circle"
        })]], 2)]), _vm._v(_vm._s(props.fileInfo.file.name)), (props.fileInfo.status == _vm.uploaderConsts.ERROR) ? [(props.fileInfo.response.error === 'NoEnoughSpace') ? [_c('div', {
          staticClass: "label label-danger"
        }, [_vm._v(_vm._s(_vm.$t('nodes.uploader.noEnoughSpace')))]), _vm._v("   "), _c('div', {
          staticClass: "btn btn-xs btn-success",
          attrs: {
            "role": "button"
          },
          on: {
            "click": _vm.openGroupAccount
          }
        }, [_vm._v(_vm._s(_vm.$t('nodes.uploader.addSpaceBtn')))])] : [_c('div', {
          staticClass: "label label-danger"
        }, [_vm._v(_vm._s(_vm.$t('nodes.uploader.error')))])]] : _vm._e(), (props.fileInfo.status == _vm.uploaderConsts.CANCELED) ? [_c('div', {
          staticClass: "label label-warning"
        }, [_vm._v(_vm._s(_vm.$t('nodes.uploader.cancelled')))])] : _vm._e(), (props.fileInfo.status == _vm.uploaderConsts.UPLOADING) ? _c('div', {
          staticClass: "progress m-t-xs full progress-striped active"
        }, [_c('div', {
          staticClass: "progress-bar progress-bar-info",
          style: ({
            width: props.fileInfo.upload.progress + "%"
          }),
          attrs: {
            "aria-valuemax": "100",
            "aria-valuemin": "0",
            "aria-valuenow": props.fileInfo.upload.progress,
            "role": "progressbar"
          }
        }, [_vm._v(_vm._s(Math.round(props.fileInfo.upload.progress)) + "%")])]) : _vm._e()], 2)])]
      }
    }])
  }), (_vm.canEdit) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "addFileCallback": _vm.dropFileCallback
    }
  }, [_c('template', {
    slot: "dropzone"
  }, [_c('strong', [_c('div', {
    staticClass: "dragdropfiles"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(_vm._s(_vm.$t("nodes.dragdropfileshere")))])])])], 2) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright pcenter"
  }, [_vm._v("© "), _c('a', {
    attrs: {
      "href": "https://groopus.com"
    }
  }, [_vm._v("GroopUs.com")]), _vm._v(". Design: GroopUs.com")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f684167c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPages.vue
// module id = 1291
// module chunks = 2